import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import {
  excludedRegexList,
  getCategoryName,
  includedRegexList,
} from '../../../utils/getCategory';
import { If } from '../../Atoms/Conditionals';
import { myImageLoader, setQueryParamToLink } from '../../Header/utils';
import { NAV_TYPES } from '../../cms/layout/components/header';
import {
  COMPANY_OPTIONS,
  HEADER_LABELS,
  PRODUCT_OPTION,
  RESOURCES_OPTIONS,
  SOLUTIONS_OPTIONS,
} from './DataConstants';
import { DropdownComponent } from './Dropdown/DynamicDropdown';
import { GeneralColDropdown } from './Dropdown/GeneralDropdown';
import { TNAVBAR_DATA } from './types';

const DesktopNavBar: React.FC<TNAVBAR_DATA> = React.memo(function DesktopNavBar(
  props
) {
  const { rightCTA, logo, type, bgColor } = props;
  const [logoURL, setLogoURL] = useState<string>('');
  const header_labels = HEADER_LABELS;

  const router = useRouter();
  const pageName = getCategoryName({
    regexList: [...includedRegexList, ...excludedRegexList],
    url: router.asPath,
    parent: true,
  });
  const refValue = `${pageName}_pages_navbar`;

  useEffect(() => {
    const link = typeof logo.link === 'function' ? logo.link() : logo.link;
    const logoUrlString = typeof link === 'string' ? link : link.logoUrl;

    const logoLink = setQueryParamToLink(logoUrlString, 'utm_ref', refValue);
    setLogoURL(logoLink);
  }, [logo]);

  return (
    <>
      <div
        className={`p-2 px-0 w-full h-16 border border-b border-b-gray-200 flex items-center fixed z-20 font-medium sm:px-0 ${
          bgColor ? bgColor : 'bg-white'
        }`}
        id="navbar"
        data-testid="Header"
      >
        <nav
          className={`flex text-s-14 z-20 w-full font-medium wg-container gap-1 ${bgColor}`}
        >
          <a href={`${logoURL}`} className="inline-flex items-center w-1/12">
            <Image
              loader={() => myImageLoader(logo.icon)}
              src="me.png"
              alt="Picture of the author"
              width={120}
              height={20}
              priority
            />
          </a>

          <If condition={type !== NAV_TYPES.DEFAULT}>
            <div
              className={`w-7/12 items-center justify-end gap-10 ${
                bgColor ? bgColor : 'bg-white'
              } inline-flex flex-grow z-50 sm:w-full sm:flex-row sm:shadow-sm`}
            >
              <DropdownComponent
                dropdownLabel={header_labels.products}
                dropdownList={PRODUCT_OPTION}
                Dropdown={GeneralColDropdown}
                hover={true}
              />

              <If condition={type === NAV_TYPES.B2B}>
                <DropdownComponent
                  dropdownLabel={header_labels.solutions}
                  dropdownList={SOLUTIONS_OPTIONS}
                  Dropdown={GeneralColDropdown}
                  hover={true}
                />
              </If>

              <DropdownComponent
                dropdownLabel={header_labels.resources}
                dropdownList={RESOURCES_OPTIONS}
                Dropdown={GeneralColDropdown}
                hover={true}
              />
              <DropdownComponent
                dropdownLabel={header_labels.company}
                dropdownList={COMPANY_OPTIONS}
                Dropdown={GeneralColDropdown}
                hover={true}
              />
            </div>
          </If>

          <div
            className={`w-4/12 sm:w-full ${
              bgColor ? bgColor : 'bg-white'
            } inline-flex flex-grow z-50 flex-row-reverse sm:flex-row sm:shadow-sm`}
          >
            <div className="flex items-center">
              <div className=" gap-4 w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto items-center flex sm:flex-col lg:h-auto xl:h-auto">
                <div className="w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto  lg:items-center items-start  flex sm:flex-col lg:h-auto xl:h-auto">
                  {rightCTA}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
});

export { DesktopNavBar };
